/**
 * Pure helpers (dates, geo, formatting) with no I/O.
 */

export * from "./geofence";
